import { render } from "./CropAreaForm.vue?vue&type=template&id=94613d0a&scoped=true&ts=true"
import script from "./CropAreaForm.vue?vue&type=script&lang=ts"
export * from "./CropAreaForm.vue?vue&type=script&lang=ts"

import "./CropAreaForm.vue?vue&type=style&index=0&id=94613d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94613d0a"]])

export default __exports__